// meta descriptions for search engines, keyed by page route (router.pathname)
// and resolved per page at static export time. every indexable page needs its
// own text — duplicate descriptions across pages hurt SEO and get flagged by
// crawlers. utils/seo.test.ts fails when a page is added without one.
export const PAGE_DESCRIPTIONS: Record<string, string> = {
  '/': "Swap crypto natively across Bitcoin, Ethereum, Solana, Tron, BNB Chain, Arbitrum and more with Chainflip's cross-chain DEX. No wrapped assets or bridges required.",
  '/terms':
    'Read the Terms of Service governing the use of Chainflip Swap, including eligibility, responsibilities, and supported services.',
  '/privacy':
    'Learn how Chainflip Swap collects, uses, and protects your information in our Privacy Policy.',
};

// dynamic routes (e.g. shared swap status pages) fall back to the root description
export const getPageDescription = (pathname: string): string =>
  PAGE_DESCRIPTIONS[pathname] ?? PAGE_DESCRIPTIONS['/'];

// title tags, keyed like PAGE_DESCRIPTIONS. duplicate titles across pages hurt
// ranking and get flagged by crawlers, so every indexable page needs its own
export const PAGE_TITLES: Record<string, string> = {
  '/': 'Chainflip Cross-Chain Swaps',
  '/terms': 'Chainflip Swaps Terms of Service',
  '/privacy': 'Chainflip Swaps Privacy Policy',
};

// dynamic routes (e.g. shared swap status pages) fall back to the root title
export const getPageTitle = (pathname: string): string => PAGE_TITLES[pathname] ?? PAGE_TITLES['/'];
